import {Select, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {SessionGenInfoSessionCallDurationFormFieldProps} from "../types";
import {SessionGenInfoFormFields} from "../../types";

export const CallDurationOptions = [
  {
    label: "15 Minutes",
    value: "15",
  },
  {
    label: "30 Minutes",
    value: "30",
  },
  {
    label: "45 Minutes",
    value: "45",
  },
  {
    label: "60 Minutes",
    value: "60",
  },
  {
    label: "Custom",
    value: "-1",
  },
];

export function SessionGenInfoSessionCallDurationFormField({
  id,
  label,
  placeholder,
}: SessionGenInfoSessionCallDurationFormFieldProps) {
  const {control} = useFormContext<SessionGenInfoFormFields>();

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Controller
            control={control}
            name="callDuration"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={onChange}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  options={CallDurationOptions}
                  placeholder={placeholder}
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
